import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FadeInOnIntersectingDirective } from './fade-in-on-intersecting.directive';
import { FadeInOnIntersectingService } from './fade-in-on-intersecting.service';

@NgModule({
    declarations: [FadeInOnIntersectingDirective],
    imports: [CommonModule],
    exports: [FadeInOnIntersectingDirective],
    providers: [FadeInOnIntersectingDirective]
})
export class FadeInOnIntersectingModule {
    // Ensure that only one instance of login service is instantiated
    // static forRoot(): ModuleWithProviders {
    //     return {
    //         ngModule: FadeInOnIntersectingModule,
    //         providers: [
    //             FadeInOnIntersectingService
    //         ]
    //     };
    // }
}
